import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass der Zeiterfassungs-Tab erst lädt, wenn der Tab-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'time-tracking',
  name: 'Time-Tracking',
  description:
    'Zeiterfassung pro Projekt auf Positionen (Leistungsarten), Auswertung ' +
    'je Position und Person, projektspezifische Stundensätze und ' +
    'CSV-Rechnungsentwurf. Wird nur angezeigt, wenn der Admin das ' +
    'Feature-Flag „timeTrackingEnabled" aktiviert hat.',
  category: 'core',
  version: '0.2.0',
  requiredPermissions: [Permission.TIME_LOG_WRITE],
  enabledByDefault: true,
};

const TimeTrackingTab = lazy(() =>
  import('./TimeTrackingTab').then((m) => ({ default: m.TimeTrackingTab })),
);

export const timeTrackingSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'time-tracking',
        order: 70,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: TimeTrackingTab,
      },
    ],
  },
};
